import DeleteInfoDialog from './components/DeleteInfoDialog';

export default DeleteInfoDialog;
